export default __webpack_public_path__ + "static/media/control.b5e68760.svg";